import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import UserManagement from "../components/UserManagement/UserManagement";
import { fetchUserList } from "../actions/usermanagement";
import { fetchUserInfo } from "../actions/user";

const mapStateToProps = (state) => {
  return {
    isFetching: state.userManagement.isFetching,
    data: state.userManagement.data,
    count: state.userManagement.count,
    error: state.userManagement.error,

    user_info: state.login.user_info,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchUserList,
      fetchUserInfo
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);
